import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[digitAddMinusCommas]'
})
export class DigitAddMinusCommasDirective {

  locale: string = 'en-US'; // Default Language
  @Input() decimalPlaces: any;
  elementValue: any;
  // isDisable:boolean = true;
  @Input() isDXCComponent: boolean = false; // false => span, p, label,... tag / true => dxc component
  private decimalSeparatorCount: number = 0;
  private initialValue;
  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste'
  ];
  private numberRegex: RegExp = /^-?[0-9]\d*(\.\d+)?$/;

  constructor(
    public el: ElementRef,
    private renderer2: Renderer2
  ) { }

  ngOnChanges() {
    console.log('ngOnChanges');
    if (this.isDXCComponent === true) {
      this.elementValue = this.el.nativeElement.firstElementChild.firstElementChild.firstElementChild.firstElementChild.nextElementSibling;
    } else {
      this.elementValue = this.el.nativeElement;
    }
  }
  ngOnInit() {
    this.setDecimalPlaces();
  }
  setDecimalPlaces() {
    this.decimalPlaces = (this.decimalPlaces ? this.decimalPlaces : 2);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.isDXCComponent === true) {
        let elementValue = this.elementValue.value;
        this.elementValue.value = elementValue;
      } else {
        this.elementValue.value = this.el.nativeElement.textContent;
        this.elementValue.disabled = true;
      }
      this.formatValue(this.elementValue.value);
    }, 500);
  }
  ngOnDestroy() {
    //onDestroy
  }
  ngAfterViewChecked() {
    //onAfterViewCheck
  }

  @HostListener('keydown', ['$event']) onKeydown(e: KeyboardEvent) {
    console.log('keydown', e);
    if (
      this.allowNavigationKeys(e.key) || // Allow: navigation keys: backspace, delete, arrows etc.
      this.checkCtrl(e) ||
      this.checkCmd(e) ||
      this.checkMinusNumber(e) ||
      this.checkDeciamlPoint(e) // Allow: only one decimal point
    ) {
      // let it happen, don't do anything
      return;
    }
    if (!this.numberRegex.test(e.key)) {
      // Ensure that it is a number and stop the keypress
      e.preventDefault();
    }
  }
  // Allow: navigation keys: backspace, delete, arrows etc
  allowNavigationKeys(keyValue) {
    return this.navigationKeys.indexOf(keyValue) > -1;
  }
  checkCtrl(e) {
    switch (e.key) {
      case 'a': // Allow: Ctrl+A
      case 'c': // Allow: Ctrl+C
      case 'v': // Allow: Ctrl+V
      case 'x': // Allow: Ctrl+X
        return e.ctrlKey === true;
      default:
        return false;
    }
  }
  checkCmd(e) {
    switch (e.key) {
      case 'a': // Allow: Cmd+A (Mac)
      case 'c': // Allow: Cmd+C (Mac)
      case 'v': // Allow: Cmd+V (Mac)
      case 'x': // Allow: Cmd+X (Mac)
        return e.metaKey === true;
      default:
        return false;
    }
  }
  // Check decimal point
  checkDeciamlPoint(e) {
    return (e.key === '.' && this.decimalSeparatorCount < 1);
  }

  // Check minus number
  checkMinusNumber(e) {
    return (e.key === '-');
  }

  @HostListener('input', ['$event']) onChange(event) {
  }

  @HostListener('keyup', ['$event']) onKeyUp(e: KeyboardEvent) {
    this.decimalSeparatorCount = this.elementValue.value.split('.').length - 1;
  }

  @HostListener('click', ['$event']) onClick(event: MouseEvent) {
    this.decimalSeparatorCount = this.elementValue.value.split('.').length - 1;
    if (!this.elementValue.disabled) {
      this.initialFormatValue(this.initialValue);
    }
  }

  @HostListener('focusout') onBlur(event) {
    this.formatValue(this.elementValue.value);
  }

  private initialFormatValue(formattedValue) {
    const parsedValue = formattedValue.replace(/,/g, '');
    const regex = new RegExp(`\\.0{1,${this.decimalPlaces}}$`);
    formattedValue = parsedValue.replace(regex, '');
    if (this.isDXCComponent === true) {
      this.elementValue.value = formattedValue;
    }
  }

  private formatValue(value) {
    this.initialValue = value;
    if (this.initialValue) {
      const parsedValue = parseFloat(value.replace(/,/g, ''));
      if (!isNaN(parsedValue)) {
        const formatValue = parsedValue.toLocaleString(this.locale, {
          minimumFractionDigits: this.decimalPlaces,
          maximumFractionDigits: this.decimalPlaces
        });
        if (this.isDXCComponent === true) {
          this.elementValue.value = formatValue;
        } else {
          this.el.nativeElement.textContent = formatValue;
        }
      }
    }
  }
}